import axios, { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { request } from '../../helpers/request';
import { FETCH_TESTIMONIAL_SUCCESS } from '../types/testimonialType';

export const getTestimonials = (dispatch: Dispatch) => {
    return request
        .getTestimonials()
        .then((response: AxiosResponse) => {
            dispatch({
                type: FETCH_TESTIMONIAL_SUCCESS,
                payload: response.data?.testimonials
            });
        })

        .catch((err: AxiosError | Error) => {
            if (axios.isAxiosError(err)) {
                console.log(err.response?.data);
            } else {
                console.log(err.message);
            }
        });
};
